import { render, staticRenderFns } from "./viewNutritionReport.vue?vue&type=template&id=9ae7054c&"
import script from "./viewNutritionReport.vue?vue&type=script&lang=js&"
export * from "./viewNutritionReport.vue?vue&type=script&lang=js&"
import style0 from "./viewNutritionReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports